export default __webpack_public_path__ + "static/process3-f7ac1ae06c25317fa6a0e8505f646726.png";